/** ===================================
 * LINKS PAGE
 ===================================== */

/* Declare GSAP timelines */
let timeline_links_page = new TweenMax({paused: true});

// listen for changes to document.readyState - onreadystatechange is
// fired when readyState value is changed
document.onreadystatechange = function () {
    // check the value - if it's 'interactive' then the DOM has loaded
    if (document.readyState === "interactive") {
        jQuery(document).ready(function( $ ) {
            const $wrapper = $('#wrapper');
            let $links = $wrapper.find('#links-wrapper a.link');

        	/* GSAP animations */
    		const link_elements = $links.toArray();
            // console.dir(link_elements);

            TweenMax.staggerFrom(link_elements, 0.3, {
                x: -70,
                opacity:0,
                delay:0.5,
                ease:Ease.easeInOut,
                force3D:true},
            0.5);
        });


    }
}